const FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

/**
 * "January 23, 2013" — the app-standard long date. en-US, viewer timezone.
 * Returns `null` for missing or unparseable input so call sites keep their
 * own fallbacks.
 */
export function formatLongDate(input: Date | string | null | undefined): string | null {
  if (!input) return null;
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return null;
  return FORMATTER.format(date);
}

/**
 * Long date from a Unix epoch in seconds (e.g. Stack Overflow
 * `creation_date`). Returns `null` if the input is missing.
 */
export function formatLongDateFromUnix(
  seconds: number | null | undefined,
): string | null {
  if (seconds == null || !Number.isFinite(seconds)) return null;
  const date = new Date(seconds * 1000);
  if (Number.isNaN(date.getTime())) return null;
  return FORMATTER.format(date);
}
